export default "__VITE_ASSET__f2af44d1__"